import {
    CREATE_OPPORTUNITY,
    OPPORTUNITY_LIST,
    OPPORTUNITY_QUESTION,
    GET_OPPORTUNITY_BY_ID,
    UPDATE_OPPORTUNITY,
    FILTER_CONTENT,
    PROPOSAL_COMMERCIAL_CLOSURE
} from "./type";

const initialState = {
    saveDetails: [],
    opportunityList: [],
    opportunityQuestion: [],
    opportunityDetails: [],
    updateOpportunityDetails:[],
    getFilterContent:[],
    proposalCommercialDetails:[]
};

const Opportunitie = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case CREATE_OPPORTUNITY:
            return {
                ...state,
                saveDetails: payload,
            };
        case OPPORTUNITY_LIST:
            return {
                ...state,
                opportunityList: payload,
            };
        case OPPORTUNITY_QUESTION:
            return {
                ...state,
                opportunityQuestion: payload,
            };
        case GET_OPPORTUNITY_BY_ID:
            return {
                ...state,
                opportunityDetails: payload,
            };
        case UPDATE_OPPORTUNITY:
            return {
                ...state,
                updateOpportunityDetails: payload,
            };
        case FILTER_CONTENT:
            return {
                ...state,
                getFilterContent: payload,
            };

        case PROPOSAL_COMMERCIAL_CLOSURE:
            return {
                ...state,
                proposalCommercialDetails: payload,
            };
        default:
            return {...state};
    }
};

export default Opportunitie;